<!-- =========================================================================================
  File Name: FormWizardValidation.vue
  Description: Form wizard with validation
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="extra-component-form-wizard-demo">
    <p class="mb-4">
      Put paintings & photography on any wall on earth. Turn PNG and JPG images into a framed version that can be
      virtually hung on any wall.
    </p>

    <vx-card title="Create a wall art digital twin" code-toggler>
      <!-- <p>Implement Form validation with form wizard using popular <strong> <router-link to="/forms/form-validation">VeeValidate</router-link></strong></p> -->

      <div class="mt-5">
        <form-wizard
          ref="wizard"
          color="rgba(var(--vs-primary), 1)"
          errorColor="rgba(var(--vs-danger), 1)"
          :title="null"
          :subtitle="null"
          finishButtonText="Create"
        >
          <tab-content title="Step 1" class="mb-5" icon="feather icon-home" :before-change="validateStep1">
            <!-- tab 1 content -->
            <form data-vv-scope="step-1">
              <file-pond
                :imageResizeTargetWidth="1024"
                :imagePreviewHeight="300"
                name="test"
                ref="pond"
                label-idle="Drop your image here..."
                :server="{ process, revert, restore, load, fetch }"
                :allow-multiple="false"
                accepted-file-types="image/jpeg, image/png"
                :files="filepondFile"
              />

              <div class="vx-row">
                <div class="vx-col w-1/2 mt-5">
                  <!-- 
                            <vs-row v-if="IsIOS" vs-w="12">
                                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
                                    <input type="file" class="hidden w-full upload-img mt-5" ref="uploadImgInput" @change="uploadFileiOS" accept="image/*" />
                                    <vs-button @click="$refs.uploadImgInput.click()">Upload Image</vs-button>
                                </vs-col>
                            </vs-row>

                            <vs-upload v-else automatic action="https://jsonplaceholder.typicode.com/posts/" limit="1" @on-error="uploadFile" @on-success="uploadFile" /> -->

                  <span class="text-danger">{{ errors.first('step-1.image_upload') }}</span>
                </div>
              </div>
            </form>
          </tab-content>

          <!-- tab 2 content -->
          <tab-content title="Step 2" class="mb-5" icon="feather icon-briefcase" :before-change="validateStep2">
            <form data-vv-scope="step-2">
              <vs-row vs-w="12">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                  <vs-input
                    label="Title"
                    v-model="name"
                    class="w-full"
                    name="name"
                    v-validate="{
                      max: 64,
                      required: true,
                      regex: /^[a-zàâçéèêëîïôûùüÿñæœ\d\-._\s]+$/i,
                    }"
                  />
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12">
                  <vs-input label="Physical height" v-model="height" name="height" />
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
                  <ul class="leftx margin-top">
                    <li>
                      <vs-radio v-model="unit" vs-name="radios1" vs-value="cm">cm</vs-radio>
                    </li>
                    <li>
                      <vs-radio v-model="unit" vs-name="radios1" vs-value="inches">inches</vs-radio>
                    </li>
                  </ul>
                  <!-- <vs-select v-model="unit" label="Unit">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in unitOptions" />
            </vs-select>   -->
                </vs-col>

                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12">
                  <div class="margin-top">
                    <ul class="centerx">
                      <li>
                        <vs-checkbox v-model="virtualFrame">Virtual Frame</vs-checkbox>
                      </li>
                    </ul>
                  </div>

                  <!-- <vs-select v-model="virtualFrame" label="Virtual Frame">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in virtualFrameOptions" />
            </vs-select>   -->
                </vs-col>
              </vs-row>
              <span class="text-danger">{{ errors.first('step-2.name') }}</span>
            </form>
          </tab-content>

          <!-- tab 3 content -->
          <!-- <tab-content title="Step 3" class="mb-5" icon="feather icon-image" :before-change="validateStep3">
          <form data-vv-scope="step-3">

             <div class="vx-row">
            <div class="vx-col w-full">
              <vs-input label="Original page on your website. Users will be taken to this url when pressing the back button." v-model="return_url" class="w-full mt-4" name="origin_url" v-validate="'url:require_protocol|alpha_spaces'" />
              <span class="text-danger">{{ errors.first('step-3.origin_url') }}</span>

              <vs-input label="Physical height. The width is automatically calculated based on the image aspect ratio
If you provide no size, the object will be resizable by pinching it" v-model="height" class="w-full mt-4" name="height" />
              <span class="text-danger">{{ errors.first('step-3.height') }}</span>
            </div>
            <div class="vx-col w-full">
              <vs-textarea v-model="description" label="Short description" class="md:mt-10 mt-6 mb-0" rows="3" />
            </div>
          </div>

          </form>
        </tab-content> -->
        </form-wizard>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vueFilePond from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'

import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImageTransform from 'filepond-plugin-image-transform'
import FilePondPluginImageResize from 'filepond-plugin-image-resize'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginImageExifOrientation,
  FilePondPluginImageResize,
  FilePondPluginImageTransform
)

import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import moduleDataList from '@/store/data-list/moduleDataList.js'

// For custom error message
import { Validator } from 'vee-validate'
const dict = {
  custom: {
    image_upload: {
      required: 'We are trying to create an AR image, you must upload a photo first',
      alpha: 'Job title may only contain alphabetic characters',
    },
    height: {
      required: 'Job title name is required',
      alpha: 'Job title may only contain alphabetic characters',
    },
    // origin_url: {
    //   required: 'Proposal title name is required',
    //   alpha: 'Proposal title may only contain alphabetic characters'
    // },
    name: {
      required: 'Title is required',
      alpha: 'Title name may only contain alphabetic characters',
    },
  },
}

// register custom messages
Validator.localize('en', dict)

export default {
  data() {
    return {
      filepondFile: [],
      image: null,
      name: '',
      imageUrl: '',
      height: 100,
      description: '',
      asset_text: '',
      unit: 'cm',
      return_url: '',
      unitOptions: [
        {
          text: 'cm',
          value: 'cm',
        },
        {
          text: 'inches',
          value: 'inches',
        },
      ],
      virtualFrame: false,
      virtualFrameOptions: [
        {
          text: 'Yes',
          value: 'yes',
        },
        {
          text: 'No',
          value: 'no',
        },
      ],
    }
  },
  computed: {
    IsIOS() {
      return (
        ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
          navigator.platform
        ) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
      )
    },
  },
  created() {
    if (!moduleDataList.isRegistered) {
      this.$store.registerModule('dataList', moduleDataList)
      moduleDataList.isRegistered = true
    }

    var layer_name = JSON.parse(localStorage.getItem('layerInfo')).name
    this.return_url = `https://studio.hoverlay.com/public/${layer_name}`
  },
  methods: {
    process(fieldName, file, metadata, load, error, progress, abort) {
      // if (!this.hobject.name) {
      //     this.hobject.name = file.name.replace(/\.[^/.]+$/, "")
      // }
      this.image = file
      load(file)
      // Should expose an abort method so the request can be cancelled
      return {
        abort: () => {
          // Let FilePond know the request has been cancelled
          abort()
        },
      }
    },
    load(source, load, error, progress, abort, headers) {
      var myRequest = new Request(source)
      fetch(myRequest).then(function (response) {
        response.blob().then(function (myBlob) {
          load(myBlob)
        })
      })
    },

    fetch(url, load, error, progress, abort, headers) {
      console.log('fetch')
      console.log(url)

      var myRequest = new Request(url)
      fetch(myRequest).then(function (response) {
        response.blob().then(function (myBlob) {
          load(myBlob)
        })
      })

      // console.log("original_image")
      // url = this.hobject.original_image
      // error("Local files only");
    },

    restore(uniqueFileId, load, error, progress, abort, headers) {
      // error();
    },

    revert(uniqueFileId, load, error) {
      // TODO -> AlbumRepository delete photo
      // load();
    },
    async CreateWallArt() {
      console.log('SUBMIT')
      var validation = await this.$validator.validateAll()

      let computedHeight = ''
      if (validation) {
        this.height = parseFloat(this.height)
        if (isNaN(this.height)) {
          computedHeight = 1
        } else if (this.unit === 'inches') {
          computedHeight = this.height * 0.0254
        } else {
          computedHeight = this.height / 100
        }
        var hobject = {
          name: this.name,
          model_identifier: 'hoverlay.art.WallArt.1.0',
          description: this.description,
          image: this.image,
          /* INDOORS_WALL Anchor */
          // anchor_pid: 247,
          // layer_pid: JSON.parse(localStorage.getItem('layerInfo')).pid,
          // return_url: this.return_url,
        }
        console.log(hobject)

        if (this.virtualFrame)
          hobject.abilities = `{"skin":{"source_url":"","type":"image","height":${computedHeight}},"frame":{},"interactions":{"start_behavior":"to_be_placed","orientable_by_user":"false","resizable_by_user":"false"}}`
        else
          hobject.abilities = `{"skin":{"source_url":"","type":"image","height":${computedHeight}},"interactions":{"start_behavior":"to_be_placed","orientable_by_user":"false","resizable_by_user":"false"}}`

        this.$vs.loading()

        var responseS3Permission = await this.$store.dispatch('dataList/askS3permission', this.image)
        console.log(responseS3Permission)
        console.log({
          responseS3Permission,
          fileName: responseS3Permission.fileName,
          file: this.image,
        })
        var responseUploadToS3 = await this.$store.dispatch('dataList/uploadToS3', {
          signedRequest: responseS3Permission.signedRequest,
          fileName: responseS3Permission.fileName,
          file: this.image,
        })

        hobject.asset_uri = responseS3Permission.url
        hobject.manage_asset = true

        try {
          var responseHobject = await this.$store.dispatch('dataList/postHobject', hobject)

          console.log(responseHobject)
          if (responseHobject.pid) {
            var link = {
              /* INDOORS_WALL Anchor */
              anchor_pid: 247,
              layer_pid: JSON.parse(localStorage.getItem('layerInfo')).pid,
              return_url: this.return_url,
              hobject_pid: responseHobject.pid,
            }

            await this.$store.dispatch('dataList/postLink', link)

            this.$vs.notify({
              text: 'Artwork created',
              color: 'success',
              icon: 'check_box',
            })
            this.$router.push({
              name: 'data-list-thumb-view',
            })
          }
        } catch (error) {
          console.log(error)
          this.$vs.notify({
            text: error,
            color: 'danger',
            icon: 'check_box',
          })
        } finally {
          this.$vs.loading.close()
        }
      }
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-1').then((result) => {
          if (result) {
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    validateStep2() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-2').then((result) => {
          if (result) {
            this.CreateWallArt()
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
  },
  components: {
    FormWizard,
    TabContent,
    FilePond,
  },
}
</script>

<style lang="scss">
.margin-top {
  margin-top: 25px;
}
</style>
